module.exports = function() {
  return new Worker(__webpack_public_path__ + "88bb6ceba21095b1bd06.worker.js");
};